export const loadedArticlesByRecommId: Record<string, number> = {};
export const maxLoadedArticles = 30 as number;
